import { buildRequestOptionsJsonBody } from '@quintoandar/fwp-fetch';
import { firebaseAuthServiceURL, getAuthorizationUrl } from './urls';
import { request } from '../utils/request-utils';

export const getFirebaseToken = () =>
  request(firebaseAuthServiceURL(), buildRequestOptionsJsonBody('POST'));

export const authorize = ({ id, route }) =>
  request(getAuthorizationUrl(id, route));
